import DayItem from '@/common/interfaces/modules/DayItem';
import { editHtml, EditItem } from '@/utils/htmlUtils';

export interface ContentDayByDayBlockViewModel {
  Text: string;
  Days?: DayItem[];
  CostIncludes: string;
  CostNotIncludes: string;
  Prices: PricesTable;
}

export interface PricesTable {
  Header: string;
  HeaderRow: RowItem;
  Rows: RowItem[];
}

export interface RowItem {
  FirstCell: string;
  Cells: string[];
}

export const convert = (data: ContentDayByDayBlockViewModel): ContentDayByDayBlockViewModel => {
  var addClassToLink: EditItem[] = [
    { selector: 'a', fn: (a) => (a.className = 'cta cta--inline') },
  ];

  data.Text = editHtml(data.Text, addClassToLink);

  if (data.Days)
    data.Days.forEach((day) => {
      day.Text = editHtml(day.Text, addClassToLink);
    });

  return data;
};
